import { useMemo } from "react";

import { useArtworkForm } from "@design-lab/entities/artwork";
import type { DesignLabPlacementKey } from "@design-lab/entities/pinning";

export function usePlacementKey(placementSide?: "front" | "back"): DesignLabPlacementKey {
  const { form } = useArtworkForm();
  const selectedFrontPlacement = form.watch("selectedFrontPlacement") as
    | DesignLabPlacementKey
    | undefined;

  return useMemo(() => {
    if (placementSide === "back") return "back";
    if (selectedFrontPlacement === "frontLeftChest") return "frontLeftChest";
    return "front";
  }, [placementSide, selectedFrontPlacement]);
}
